export class NotificationTemplate {
    public ID: number;
    public ApplicationCode: string;
    public FileName: string;
    public Content: string;
    public IsMasterLayout: boolean = false;
    public MasterLayoutID: number;
    public MasterLayoutName: string; 
}
